import React from 'react';
import { DynamicField, DynamicFieldTypes } from 'src/components/dynamic-widget';
import DynamicFormWidget from 'src/components/dynamic-widget/DynamicFormWidget';
import { DataService } from 'src/services/data-service';
import GenericDialog from 'src/components/GenericDialog';
import { useAppDispatch } from 'src/redux/hooks';
import { showAlert } from 'src/redux/alert/alertReducer';
import { IUpdateUserPasswordModel } from '.';

interface IUpdateUserPasswordProps {
  onSuccess: () => void;
  onClose: () => void;
  userId: number;
}

const UpdateUserPassword: React.FC<IUpdateUserPasswordProps> = ({ onSuccess, onClose, userId }) => {
  const dispatch = useAppDispatch();

  const formConfig = React.useMemo((): Record<string, DynamicFieldTypes> => ({
    oldPassword: {
      type: DynamicField.TEXT,
      inputType: 'password',
      required: true,
      name: 'oldPassword',
      title: 'Old Password',
      value: '',
      disabled: false
    },
    newPassword: {
      type: DynamicField.TEXT,
      inputType: 'password',
      required: true,
      name: 'newPassword',
      title: 'New Password',
      value: '',
      disabled: false
    }
  }), []);

  const submit = React.useCallback(async (data: Record<string, any>) => {
    const payload: IUpdateUserPasswordModel = {
      id: userId,
      oldPassword: data.oldPassword,
      newPassword: data.newPassword
    };

    const response = await DataService.post(
      'api/User/update-password',
      payload,
      undefined
    );

    if (response.ok) {
      onSuccess();
      return true;
    } else {
      const result: { message: string } = await response.json();
      dispatch(showAlert({
        message: result.message || 'An error occurred while updating password!',
        type: 'error'
      }));
      return false;
    }
  }, [dispatch, onSuccess, userId]);

  return (
    <GenericDialog
      open={true}
      title="Update Password"
      onClose={onClose}
    >
      <DynamicFormWidget
        title=""
        fields={formConfig}
        onSubmit={submit}
      />
    </GenericDialog>
  );
};

export default UpdateUserPassword;
